import { render, staticRenderFns } from "./DataTableClientCost.vue?vue&type=template&id=9805ca96&scoped=true&"
import script from "./DataTableClientCost.vue?vue&type=script&lang=js&"
export * from "./DataTableClientCost.vue?vue&type=script&lang=js&"
import style0 from "./DataTableClientCost.vue?vue&type=style&index=0&id=9805ca96&prod&lang=scss&"
import style1 from "./DataTableClientCost.vue?vue&type=style&index=1&id=9805ca96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9805ca96",
  null
  
)

export default component.exports